<template>
  <div class="row">
    <div :class="labelClass" class="font-weight-bold text-right">{{ label }}</div>
    <div class="col"><slot></slot></div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },

    labelClass: {
      type: String,
      default: 'col-md-2 col-sm-3 col-5'
    }
  }
};
</script>
